import { client } from "../../utils";
import Prismic from "prismic-javascript";

export const fetchMenu = (filters) => (dispatch) => {
  client
    .query(Prismic.Predicates.at("document.type", "menu"), {
      ...filters,
    })
    .then((res) => {
      const list = res.results.sort((a, b) => {
        return a.data.order - b.data.order;
      });

      dispatch({
        type: "FETCH_MENU",
        payload: {
          ...res,
          results: list,
        },
      });
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/menuActions.js